export default "__VITE_ASSET__511e47bb__"